// extracted by mini-css-extract-plugin
export var cablesLeft = "InfoGraphic-module--cablesLeft--wPmok";
export var cablesWrapper = "InfoGraphic-module--cablesWrapper--RaGv3";
export var graphicCardWrapper = "InfoGraphic-module--graphicCardWrapper--5tYIx";
export var graphicColumn = "InfoGraphic-module--graphicColumn--7bVyk";
export var graphicRootDesktop = "InfoGraphic-module--graphicRootDesktop--grm-F";
export var graphicTitle = "InfoGraphic-module--graphicTitle--KBD+C";
export var imageCables = "InfoGraphic-module--imageCables--TMKUD";
export var mobileOnly = "InfoGraphic-module--mobileOnly--Bsnfl";
export var root = "InfoGraphic-module--root--rqZcV";